<section>
    <label *ngIf="options.header" class="header {{ options.headerClass }}" [ngClass]="{ 'accessibility-hidden': options.headerInvisible }" [for]="options.inputId">{{ options.header }}</label>
    <ng-content></ng-content>
    <div *ngIf="formCtrl.errors && formCtrl.dirty && formCtrl.touched">
        <span class="error {{ options.class }}" id="aria-error-{{ options.inputId }}" aria-live="polite">{{ errorsToShow }}</span>
    </div>
</section>
